import React, { useState, useEffect } from "react";
import "./employee-details-content.component.scoped.scss";
import { EmployeesContext } from "../../store";
import { FormControl, Select, MenuItem, Grid, Button } from "@material-ui/core";
import { icons } from "../../statics/icons";
import { useTranslation } from "react-i18next";
import { SectionInfoComponent } from "../section-info/section-info.component";
import { ChartComponent } from "../chart/chart.component";
import { ChartDoughnutComponent } from "../chart-doughnut/chart-doughnut.component";
import { MapperService } from "../../services/mapper/mapper.service";
import { ReviewStarsComponent } from "../review-stars/review-stars.component";
import { ReviewCardComponent } from "../review-card/review-card.component";
import { EmployeesService } from "src/services/employees/employees.service";
import { filters } from "../../statics/stats";
import { BuildingsSectionComponent } from "../buildings-section/buildings-section.component";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
export default function EmployeeDetailsContent(props: any) {
  const employeesService = new EmployeesService();
  const mapperService = new MapperService();

  const [t] = useTranslation();

  const {
    buildings,
    reviews,
    rate,
    activeFilter,
    activeRange,
    setChartFilter,
    setWorkingHours,
    setBuildings,
    setTasks,
    setActivities,
    activities,
    setChartLabels,
    workingHours,
    setRate,
    setReviews,
    chartLabels
  } = React.useContext(EmployeesContext);

  const [selectedFilter, setFilter] = useState(activeFilter);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setChartFilter(event.target.value);
    setFilter(event.target.value);
  };

  async function fetchData(emplyeeId: string, from: string, to: string, filter: string) {
    const stats = await employeesService.listEmployeesStats(emplyeeId, from, to, filter);
    const { labels, data } = mapperService.workingHoursChart(stats.workingHours, filter);
    setChartLabels(labels);
    setWorkingHours(data);
    setTasks(mapperService.tasksChart(stats.tasks));
    setBuildings(stats.buildings);
    setRate(stats.rate);
    const mappedRevies = mapperService.employeeReviews(stats);
    setReviews(mappedRevies);
    setActivities(mapperService.activitiesChart(stats.tasks));
  };

  const print = () => {
    window.print();
  }

  useEffect(() => {
    fetchData(props.emplyeeId, activeRange.from, activeRange.to, activeFilter);
    // eslint-disable-next-line
  }, [activeRange]);

  return (
    <div className="main-container">
      <div className="stats-header">
        <div className="filter">
          <FormControl variant="outlined" className="chart-filter">
            <Select
              labelId="chart-select-label"
              id="chart-select"
              value={selectedFilter}
              onChange={handleChange}
              label="Filter"
            >
              {filters.map((item: any, index: any) => {
                return (
                  <MenuItem value={item.value} key={index}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            className="btn-tool btn-warning"
            onClick={print}
          >
            <img
              alt="icon"
              className="icon icon-refresh"
              src={icons.printWhiteIco}
            />
            <span className="hide-on-mobile">{t("print")}</span>
          </Button>
        </div>
      </div>
      <section className="main-section">
        <Grid container direction="row" justify="space-between">
          <Grid item xs={12} sm={3} style={{marginTop: '-40px'}}>
          <SectionInfoComponent
              title="reviews"
            />
            <ReviewStarsComponent withText={true} count={rate} total={5}/>
          </Grid>
          <Grid className="reviews-area" item xs={12} sm={8}>
            <Grid container spacing={0}>
              { 
                reviews.map((item: any) => (
                <Grid item sm={12} md={6} style={{ textAlign: "center", flexGrow: 1, paddingRight: 10 }}>
                  <ReviewCardComponent data={item}/>
                </Grid>)
                )
              }
            </Grid>
          </Grid>
        </Grid>
        <div className="show-more">
          <Button
            variant="outlined"
            className="show-more-btn"
          >
            <ExpandMoreIcon className="expand-icon"/>
            <span>{t("show-more")}</span>
          </Button>
        </div>
      </section>
      <section className="main-section">
        <Grid container direction="row" justify="space-between">
          <Grid item xs={12} sm={3}>
            <SectionInfoComponent
              title="working hours"
              subTitle="these are the hours recorded by the emergency personnel"
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <div className="chart" style={{marginLeft: '-5px'}}>
              <ChartComponent
                data={workingHours}
                labels={chartLabels}
                name="workingHours"
                yAxisSuffix="h"
                unit={t("hours")}
              />
            </div>
          </Grid>
        </Grid>
      </section>
      <section className="main-section">
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12} sm={6} md={3} style={{paddingLeft: 0}}>
            <SectionInfoComponent
              title="locations"
              subTitle='locations this month'
              extendSubtitle={': number'}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} style={{paddingLeft: 0}}>
            <div className="employees-section">
              <BuildingsSectionComponent buildings={buildings}/>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={2} lg={3}>
            <SectionInfoComponent
              title="activities"
              subTitle="total working hours in the selection period divided into activities"
            >
              <div className="chart-stats">
              {activities.labels.map((item: any, index: any) => {
                return (
                  <div className="stats-row" key={index}>
                    <div className="stats-color" style={{backgroundColor: activities.colors[index]}}></div>
                    <div className="stats-label">{item}</div>
                  </div>
                );
              })}
              </div>
            </SectionInfoComponent>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            { activities.total !== "00:00" && <div className="chart">
              <ChartDoughnutComponent
                data={activities?.data}
                labels={activities?.labels}
                colors={activities?.colors}
                total={activities?.total}
                name="activities"
                unit={t("activities")}
              />
            </div>
          }
          </Grid>
        </Grid>
      </section>
    </div>
  );
}
